import { jsx as r } from "react/jsx-runtime";
import { useRef as l, useEffect as c } from "react";
import { NeuAlertContextual as s } from "@hcahealthcaredpx/neutron-react";
const p = ({ children: n, ...i }) => {
  const e = l(null);
  return c(() => {
    const t = e.current;
    if (!t) return;
    const o = t.getBoundingClientRect().top;
    (o < 0 || o > window.innerHeight) && t.scrollIntoView({ behavior: "smooth" });
  }, []), /* @__PURE__ */ r("div", { ref: e, children: /* @__PURE__ */ r(s, { ...i, children: n }) });
};
export {
  p as S
};
